import styles from './PatientSays.module.css';

/**
 * RL-1695: "Patient says: …", what the patient typed in the app when booking
 * (or changed at the day-before check-in), so the desk and the doctor do not
 * ask again. Nothing for a walk-in or when none was given.
 */
export function PatientSays({
  reason,
  compact = false,
}: {
  reason: string | null | undefined;
  /** A muted line under a name in a list. */
  compact?: boolean;
}) {
  const text = reason?.trim();
  if (!text) return null;
  return (
    <p className={compact ? `${styles.says} ${styles.compact}` : styles.says}>
      <span className={styles.label}>Patient says:</span> {text}
    </p>
  );
}
